import localforage from 'localforage';

export default function initLocalforage(): void {
  localforage.config({
    name: 'ITIMBH',
    version: 1.0,
    storeName: 'itimbh_storage',
  });
}
